import { makeStyles } from "@material-ui/core/styles";
export const cabeceraStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      padding: "10px",
      margin: "0",
      marginBottom: "20px",
      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    },
    cabecera: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    flexLista: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        padding: "0",
        margin: "5px 0",
    },
    lista: {
        listStyle: "none",
        padding: "0",
        margin: "5px 20px 10px 0"
    },
    title: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "cemter",
      alignItems: "center",
      padding: "0",
      margin: "5px 0",
    },
    containerHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0",
      margin: "5px 2rem",
    }
  }));